import { TraitRegistryCategory } from '../TraitRegistryCategory';
import { TraitTypeSelectWithPreview } from '../traitTypes/TraitTypeSelectWithPreview';
export class TraitRegistryCssEffects extends TraitRegistryCategory {
    label = 'Effekte';
    constructor(parent) {
        super(parent);
        super.init();
    }
    filter = () => new TraitTypeSelectWithPreview( /*{
      default: 'none'
    }*/);
}
